import React, { useState } from 'react';
import { Box } from '@mui/material';
import SWMSDetails from './SWMSDetails';
import ProjectSWMSList from './ProjectSWMSList';
import SimpleTabComponent from '../../../components/SimpleTabComponent';

interface ProjectSWMSOverviewProps {
  projectInternalId: number;
}
const ProjectSWMSOverview: React.FC<ProjectSWMSOverviewProps> = ({
  projectInternalId,
}) => {
  const tabLabels = ['Details', 'SWMS'];
  const [tabIndex, setTabIndex] = useState(0);

  const TabContent = () => {
    return (
      <Box sx={{ display: 'grid', gap: '16px' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        ></Box>

        {tabIndex === 0 && (
          <SWMSDetails projectInternalId={projectInternalId} />
        )}
        {tabIndex === 1 && (
          <ProjectSWMSList projectInternalId={projectInternalId} />
        )}
      </Box>
    );
  };
  const changeTabHandler = (newIndex: number) => setTabIndex(newIndex);

  return (
    <Box sx={{ width: '100%' }} className="mt-4">
      <SimpleTabComponent
        currentTab={tabIndex}
        labels={tabLabels}
        tabContent={<TabContent />}
        onChangeTab={changeTabHandler}
      />
    </Box>
  );
};
export default ProjectSWMSOverview;
